export default __webpack_public_path__ + "static/media/Frame.7ae6736c.png";